
const aboutMLD = {
    "About MLDs": [
        {
          question: "What are MLDs?",
          answer: "Market Linked Debentures (MLDs) are debt instruments that offer returns linked to the performance of an underlying financial market index." +
            "<br /><br />" +
            "MLD’s are a type of debt instrument issued by companies to raise funds from the public. They combine the features of Traditional debentures with investment characteristics linked to the performance of the financial markets or specific assets like stocks, indices or commodities."
        },
        {
          question: "Why have we not come across MLDs before?",
          answer: "MLDs were mostly accessible to Institutions and High-net-worth individuals due to their complexity and tailored nature. Additionally, the ticket size to investment was often out of reach to a lay investor."
        },
        {
          question: "What are the types of MLDs?",
          answer: "There are two main types of MLD’s.<br />" +
            "<b>Principal protected MLD’s</b> : These MLD’s guarantee the repayment of the principal amount irrespective of the market performance. They offer downside protection to investors in case of adverse market conditions." +
            "<br /><br />" +
            "<b>Non Principal Protected MLD’s</b> : These MLD’s do not guarantee the repayment of the principal amount and expose investors to market risk. They offer potentially higher returns than the principal protected MLD’s but also carry a risk of capital loss."
        },
        {
          question: "What are the main Risks of an MLD?",
          answer: "Market risk: The returns on the MLD depend upon the performance of the underlying. Although the Market risk is reduced compared to the risk of the underlying since usually, the principal is protected. On the other hand, if the underlying outperforms significantly, that may not translate into gains for the MLD since there would be a cap on the return.<br /><br />" +
            "<b>Credit Risk:</b> : MLDs are issued by Banks/ NBFCs and it is important to consider the financial condition of the issuer before investing. This risk should be assessed in the same way as when investing in a regular bond issued by the issuer." +
            "<br /><br />" +
            "<b>Liquidity Risk:</b> : MLD’s may not have an active secondary market, making it challenging for the investors to sell their holdings before maturity. MLDs are very customized and the returns on the MLD are not fully realized till the maturity of the product. For these reasons, MLDs are usually Buy and Hold investments."
        },
        {
          question: "How are MLDs Taxed?",
          answer: "Any gains arising due to sale, maturity or redemption will be treated as Short term capital gains, irrespective of the holding period and listing status and hence will be taxed as per the investors tax slab."
        },
        {
          question: "Would there be an TDS on the coupon/return of MLD?",
          answer: "Yes, the Coupon/Return at the end of the maturity of the MLD would be paid after deducting tax on the same at the rate of 10% as per Section 193."
        },
        {
          question: "Do MLDs have a Credit Rating?",
          answer: "An MLD may or may not be Credit Rated. Although, Credit Rating is mandatory if the MLD has to be listed on the stock exchanges."
        },
        {
          question: "Are MLDs secured?",
          answer: "Just like an NCD, an MLD may or may not be secured."
        },
        {
          question: "Are MLDs Regulated?",
          answer: "MLDs are a form of debentures and hence get regulated by SEBI."
        },
        {
          question: "Is a DEMAT account mandatory to Invest in an MLD?",
          answer: "Yes, a DEMAT account is mandatory since the MLD will be credited directly into your DEMAT account."
        },
      ],
  }
  
  export default aboutMLD;